import { createAction } from "redux-actions";
import { LocalStorage } from "../site/localStorage";
import ActionTypes from "actions/action-types";

const localStorageClient = new LocalStorage("tooltips");

const actions = {
  tooltipSettings: createAction(ActionTypes.TOOLTIP_SETTINGS),

  // tooltipKey should probably be your component's name
  // initialSettings are any defaults that will be overridden if localStorage
  // for the tooltipKey exist
  initializeTooltipSettings(tooltipKey) {
    return function (dispatch) {
      const tooltipSettings = {
        [tooltipKey]: {
          ...localStorageClient.get(tooltipKey),
          loaded: true,
        },
      };

      dispatch(actions.tooltipSettings(tooltipSettings));
    };
  },

  updateTooltipSettings(tooltipKey, fnSettings) {
    return function (dispatch) {
      const previousTooltipSettings = localStorageClient.get(tooltipKey) || {};

      const tooltipSettings = {
        ...previousTooltipSettings,
        ...fnSettings(previousTooltipSettings),
        loaded: true,
      };

      localStorageClient.set(tooltipKey, tooltipSettings);

      dispatch(actions.tooltipSettings({ [tooltipKey]: tooltipSettings }));
    };
  },
};

export default actions;

export const { tooltipSettings, initializeTooltipSettings, updateTooltipSettings } = actions;
